import { ErrorTemplate } from "@circle-react/components/shared/ErrorPages/ErrorTemplate";
import { useEffect } from "react";

import { t } from "@/i18n-js/instance";
import { checkoutSessionStepStatuses } from "@/react/types/Paywalls/Checkout/Session";

import { CheckoutPage } from "../../Checkout/CheckoutPage";
import { useCheckoutSession } from "../../Checkout/contexts/CheckoutSessionContext";
import { isSessionPending } from "../../Checkout/helpers/sessions/SessionStatusHelper";
import { isStepPending } from "../../Checkout/helpers/sessions/StepStatusHelper";
import { useUpdateSessionStep } from "../../Checkout/hooks/sessions/useUpdateSessionStep";
import {
  getMainStep,
  getMainPaywallId,
} from "../helpers/SessionStepQueryHelper";
import { MainOfferPage } from "../pages/MainOfferPage";

export const MainOfferRoute = () => {
  const { session } = useCheckoutSession();
  const { mutate: updateSessionStep, isPending: isUpdatingStep } =
    useUpdateSessionStep();

  const mainStep = getMainStep(session?.steps || []);
  const mainPaywallId = getMainPaywallId(session);
  const isPending = isStepPending(mainStep);

  useEffect(() => {
    if (
      session &&
      isSessionPending(session) &&
      mainStep &&
      mainPaywallId &&
      isPending
    ) {
      updateSessionStep({
        stepId: mainStep.id,
        paywallId: mainPaywallId,
        status: checkoutSessionStepStatuses.offered,
      });
    }
  }, [session, mainStep, mainPaywallId, isPending, updateSessionStep]);

  if (!session || isUpdatingStep) {
    return <CheckoutPage.Skeleton />;
  }

  if (!mainStep) {
    return (
      <ErrorTemplate
        errorCode={404}
        title={t("paywall_checkout.error_boundary.title")}
      />
    );
  }

  return <MainOfferPage stepId={mainStep.id} />;
};
